import React from "react";
import { newLogo } from "../../assets/Images";

const newsItems = [
  {
    date: "25 May, 2024",
    tags: ["News", "Audiobook"],
    title: "Lorem Ipsum",
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
  },
  {
    date: "25 May, 2024",
    tags: ["News", "Audiobook"],
    title: "Lorem Ipsum",
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
  },
  {
    date: "25 May, 2024",
    tags: ["News", "Audiobook"],
    title: "Lorem Ipsum",
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s."
  }
];

export default function NewsGridNews() {
  return (
    <section className="w-full py-16 px-6 bg-transparent text-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {newsItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-[#111]/80 backdrop-blur-sm border border-neutral-900 rounded-xl overflow-hidden hover:border-secondary hover:shadow-[0_0_20px_rgba(255,140,33,0.15)] transition-all duration-350 flex flex-col p-5 group"
            >
              {/* Media Thumbnail Container */}
              <div className="w-full aspect-[16/10] bg-black rounded-lg border border-neutral-800 flex flex-col items-center justify-center p-6 mb-4 group-hover:border-secondary/40 transition-colors relative overflow-hidden">
                <img
                  src={newLogo}
                  alt="BAB Logo"
                  className="object-contain h-16 w-auto mb-2 drop-shadow-[0_4px_8px_rgba(255,140,33,0.2)]"
                />
                <span className="text-secondary font-oswald text-xs tracking-[0.2em] font-bold uppercase">
                  Coming Soon
                </span>
              </div>

              {/* Date & Tags */}
              <div className="flex items-center justify-between mt-2 mb-3">
                <span className="text-xs text-neutral-500 font-outfit font-light">
                  {item.date}
                </span>
                <div className="flex gap-2">
                  {item.tags.map((tag, tIdx) => (
                    <span
                      key={tIdx}
                      className="bg-neutral-900 border border-neutral-800 text-[10px] text-neutral-400 px-2 py-0.5 rounded-full font-outfit uppercase tracking-wider"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>

              {/* Title */}
              <h3 className="text-xl font-bold font-oswald text-white group-hover:text-secondary transition-colors duration-300 tracking-wide uppercase mb-3">
                {item.title}
              </h3>

              {/* Description */}
              <p className="text-neutral-400 font-outfit text-sm leading-relaxed mb-6 flex-grow">
                {item.description}
              </p>

              {/* Read More Link */}
              <a
                href="#read-more"
                onClick={(e) => e.preventDefault()}
                className="text-xs text-secondary font-semibold font-outfit uppercase tracking-widest flex items-center gap-1.5 hover:text-white transition-colors mt-auto"
              >
                Read More
                <svg className="w-3.5 h-3.5 transform group-hover:translate-x-1.5 transition-transform duration-300" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                </svg>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
